import BaseAPI from "../api";

const path: string = "comment";

export class CommentApi extends BaseAPI {
  static createComment(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }

  static getCommentById(id: number): Promise<any> {
    return this.api.get(`${path}/${id}`);
  }

  static updateComment(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }

  static deleteComment(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }

  static uploadCommentImage( body: any): Promise<any> {
    return this.api.post(`${path}/image`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  static getCommentList(query?: any): Promise<any> {
    return this.api.get(`${path}/list`, {
      params: { ...query },
    });
  }
}
